"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusHistoryEntryStruct = exports.StatusHistoryChangedByStruct = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
exports.StatusHistoryChangedByStruct = (0, superstruct_1.type)({
    uid: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    counterName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
exports.StatusHistoryEntryStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    changedAt: utils_1.TimestampStruct,
    /** New status after the transition (absent only for confirmation-only events). */
    status: (0, superstruct_1.optional)((0, superstruct_1.enums)(['created', 'invited', 'queued', 'processed', 'cancelled', 'rejected', 'confirmed'])),
    /** Status before the transition. */
    previousStatus: (0, superstruct_1.optional)((0, superstruct_1.enums)(['created', 'invited', 'queued', 'processed', 'cancelled', 'rejected', 'confirmed'])),
    statusChangeReason: (0, superstruct_1.optional)((0, superstruct_1.enums)([
        'noShow',
        'lateShow',
        'incomplete',
        'missingStaff',
        'overbooking',
        'technicalIssues',
        'bulkCancelled',
    ])),
    /** Set when the event is a confirmation-only change (confirmAppointment). */
    confirmation: (0, superstruct_1.optional)((0, superstruct_1.enums)(['confirmed', 'pending', 'rejected'])),
    /** True when the transition was triggered by counter automation, not a human. */
    isAutomated: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    changedBy: (0, superstruct_1.optional)(exports.StatusHistoryChangedByStruct),
});
exports.StatusHistoryEntryStruct.type = 'StatusHistoryEntry';
//# sourceMappingURL=statusHistory.js.map